// Karten-Abos (Add-ons) - Optionale Subscriptions
// Version 1.0

export interface CardSubscription {
  id: string;
  name: string;
  shortName: string;
  price: number;
  priceDisplay: string;
  maxItemsPerUpload: number;
  monthlyUploadLimit: number;
  description: string;
  features: string[];
  icon: string;
}

export const CARD_SUBSCRIPTIONS: CardSubscription[] = [
  {
    id: 'daily',
    name: 'Tageskarten-Abo',
    shortName: 'Tageskarte',
    price: 19,
    priceDisplay: '19€/Monat',
    maxItemsPerUpload: 5,
    monthlyUploadLimit: 25,
    description: 'Ideal für täglich wechselnde Tageskarten',
    features: [
      'Max. 5 Artikel pro Analyse',
      '25 Uploads pro Monat'
    ],
    icon: '📋'
  },
  {
    id: 'weekly',
    name: 'Wochenkarten-Abo',
    shortName: 'Wochenkarte',
    price: 29,
    priceDisplay: '29€/Monat',
    maxItemsPerUpload: 10,
    monthlyUploadLimit: 15,
    description: 'Für wöchentlich wechselnde Menüs',
    features: [
      'Max. 10 Artikel pro Analyse',
      '15 Uploads pro Monat'
    ],
    icon: '📅'
  },
  {
    id: 'monthly',
    name: 'Monatskarten-Abo',
    shortName: 'Monatskarte',
    price: 39,
    priceDisplay: '39€/Monat',
    maxItemsPerUpload: 15,
    monthlyUploadLimit: 10,
    description: 'Für monatlich wechselnde Speisekarten',
    features: [
      'Max. 15 Artikel pro Analyse',
      '10 Uploads pro Monat'
    ],
    icon: '🗓️'
  }
];

export function getSubscriptionById(id: string): CardSubscription | undefined {
  return CARD_SUBSCRIPTIONS.find(s => s.id === id);
}

export function calculateMonthlyTotal(selections: Record<string, number>): number {
  return CARD_SUBSCRIPTIONS.reduce((total, sub) => {
    const qty = selections[sub.id] || 0;
    return total + (sub.price * qty);
  }, 0);
}
